import React from "react";
import { View, TouchableOpacity as NativeLink, } from "react-native";
import { Text } from "../Text/Text";
import { styles, colorStyles, borderColorStyles, } from "./Link.styles";
export const Link = ({ color = "brand", underline = false, styles: userStyles, textStyles, children, ...rest }) => {
    return (React.createElement(View, { style: styles.container },
        React.createElement(NativeLink, { style: userStyles, ...rest },
            React.createElement(View, { style: [underline && styles.underline, borderColorStyles[color]] },
                React.createElement(Text, { styles: [styles.linkText, colorStyles[color], textStyles] }, children)))));
};
//# sourceMappingURL=Link.js.map